<template>
  <div>
    <Upload
      disabled
      type="drag"
      :before-upload="handleUpload"
      :action="uploadAction">
      <div style="padding: 20px 0">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <slot></slot>
      </div>
    </Upload>
  </div>
</template>

<script>
import { uploadGerberArchive } from '@/api/pcb/upload-gerber.js'

export default {
  name: 'UploadGerber',
  props: {
    pcbSpecificationId: {
      required: false
    }
  },
  data () {
    return {
      uploadAction: ''
    }
  },
  methods: {
    handleUpload: function (file) {
      if (this.pcbSpecificationId) {
        uploadGerberArchive(this.pcbSpecificationId, file).then(
          (response) => {
          }
        ).catch(error => {
          var errorMessage = ''
          this._.forEach(error.response.data.errors, function (element) {
            errorMessage = errorMessage + element.join('\r\n')
          })

          this.$Notice.error({
            title: 'Error uploading gerber file',
            desc: errorMessage
          })
        })
      } else {
        this.$Notice.error({
          title: 'Error uploading gerber file',
          desc: 'No PCB Specification created'
        })
      }
      return false
    }
  }
}
</script>
